import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import App from './App';
import GAListener from './GAListener';

// in order to make the browser back button re-render app, have to wrap it in a route
// https://github.com/facebook/react/issues/9214
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md

const AppWrapper = () => (
  <BrowserRouter>
    <GAListener>
      <Route component={App} />
    </GAListener>
  </BrowserRouter>
);

export default AppWrapper;



// WEBPACK FOOTER //
// ./src/components/AppWrapper.js